var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountProfessional',{attrs:{"professionalId":_vm.professionalId}})
}
var staticRenderFns = []

export { render, staticRenderFns }